import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { OrderQuantitySelector } from "./OrderQuantitySelector";

interface Product {
  _id: string;
  name?: string;
  price: number;
  payWhatYouCan?: boolean;
}

interface CheckoutEmailStepProps {
  email: string;
  onEmailChange: (email: string) => void;
  products: Product[];
  quantities: Record<string, number>;
  onQuantityChange: (productId: string, quantity: number) => void;
  total: number;
  amountToPay?: string;
  onAmountToPayChange?: (amount: string) => void;
}

export function CheckoutEmailStep({
  email,
  onEmailChange,
  products,
  quantities,
  onQuantityChange,
  total,
  amountToPay = "",
  onAmountToPayChange,
}: CheckoutEmailStepProps) {
  const hasPayWhatYouCan = products.some((p) => p.payWhatYouCan);
  const displayTotal =
    hasPayWhatYouCan && amountToPay
      ? (() => {
          const parsed = parseFloat(amountToPay);
          return !isNaN(parsed) && parsed >= total ? parsed : total;
        })()
      : total;

  return (
    <div className="space-y-4 flex-1">
      <OrderQuantitySelector
        products={products}
        quantities={quantities}
        onQuantityChange={onQuantityChange}
        total={displayTotal}
      />
      <div className="space-y-2">
        <Label htmlFor="customer-email">Email *</Label>
        <Input
          id="customer-email"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
        />
      </div>
      {hasPayWhatYouCan && onAmountToPayChange && (
        <div className="space-y-2">
          <Label htmlFor="amount-to-pay">Amount to pay</Label>
          <div className="flex items-center gap-2">
            <Input
              id="amount-to-pay"
              type="number"
              min={total}
              step="0.01"
              placeholder={total.toFixed(2)}
              value={amountToPay}
              onChange={(e) => onAmountToPayChange(e.target.value)}
            />
            <span className="text-sm text-muted-foreground whitespace-nowrap">
              (${total.toFixed(2)} or more)
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
